<template>

  <b-row align-h="center" align="center">
    <b-col xs="12" sm="12" md="6" lg="3" xl="3">

      <b-tabs>
        <b-tab title="Alta Factura">
          <p></p>

          <b-row>
            <b-col>
              <b-form-select v-model="proveedorSelectedValFactura" :options="proveedoresFactura" value-field="proveedor"
                text-field="proveedor"></b-form-select>
            </b-col>
          </b-row>

          <p></p>

          <b-row>
            <b-col>
              <b-form-input class="text-center" v-model="numeroFactura" placeholder="Número"></b-form-input>
            </b-col>
          </b-row>

          <b-row>
            <b-col>
              <b-form-input class="text-center" v-model="folioFiscalFactura" placeholder="Folio fiscal"></b-form-input>
            </b-col>
          </b-row>

          <p></p>

          <b-form-datepicker v-model="fechaRawFactura" placeholder="Fecha factura"
            :date-format-options="{ day: '2-digit', month: '2-digit', year: 'numeric' }"
            locale="es"></b-form-datepicker>

          <p></p>

          <b-form-datepicker v-model="fechaRawFacturaInicio" placeholder="Fecha inicial"
            :date-format-options="{ day: '2-digit', month: '2-digit', year: 'numeric' }"
            locale="es"></b-form-datepicker>

          <p></p>

          <b-form-datepicker v-model="fechaRawFacturaFinal" placeholder="Fecha final"
            :date-format-options="{ day: '2-digit', month: '2-digit', year: 'numeric' }"
            locale="es"></b-form-datepicker>
          
          <p></p>

          <b-row>
            <b-col>
              <b-form-input type="number" number class="text-center" v-model="subTotalFactura"
                placeholder="Subtotal"></b-form-input>
            </b-col>
          </b-row>
          <p></p>
          <b-row>
            <b-col>
              <b-form-input type="number" number class="text-center" v-model="ivaFactura"
                placeholder="IVA"></b-form-input>
            </b-col>
          </b-row>
          <p></p>
          <b-row>
            <b-col>
              <b-form-input type="number" number class="text-center" v-model="totalFactura"
                placeholder="Total"></b-form-input>
            </b-col>
          </b-row>
          <p></p>
          <b-row v-if="banderaBotonNuevaCarga == 0">
            <b-col>
              <b-button pill variant="success" size="lg" @click="enviarFactura()">Cargar Factura</b-button>
            </b-col>
          </b-row>
          <b-row v-if="banderaBotonNuevaCarga == 1">
            <b-col>
              <b-spinner label="Espere un momento, por favor..."></b-spinner>
            </b-col>
          </b-row>
          <b-row v-if="banderaBotonNuevaCarga == 2">
            <b-col>
              <b-alert :variant="contenidoAlertAltaFactura.includes('Error') ? 'danger' : 'success'" show>{{
                contenidoAlertAltaFactura }}</b-alert>
              <b-button pill variant="success" size="lg" @click="cargarNuevaFactura()">Limpiar formulario</b-button>


            </b-col>
          </b-row>
        </b-tab>


        <b-tab title="Alta Conciliación">
          <p></p>
          <b-row>
            <b-col>
              <b-form-select v-model="selectedFacturaConciliacion" :options="facturasConciliacion"
                value-field="descripcion" text-field="descripcion"></b-form-select>
            </b-col>
          </b-row>
          <p></p>
          <b-row>
            <b-col>
              <b-form-file v-model="conciliacionArchivo" :state="validaFormArchivoConcilia"
                placeholder="Adjunte su archivo" @change="cargarArchivoConciliacion"></b-form-file>
            </b-col>
          </b-row>
          <p></p>
          <b-row>
            <b-col>
              <b-check v-model="checkAplicar" value="true" unchecked-value="false">Aplicar</b-check>
            </b-col>
          </b-row>
          <p></p>
          <!--{{ banderaBotonNuevaConciliacion }}-->
          <b-row v-if="banderaBotonNuevaConciliacion == 0">
            <b-col>
              <b-button pill variant="success" size="lg" @click="enviarConciliacion()">Cargar Conciliación</b-button>
            </b-col>
          </b-row>
          <b-row v-if="banderaBotonNuevaConciliacion == 1">
            <b-col>
              <b-spinner label="Espere un momento, por favor..."></b-spinner>
            </b-col>
          </b-row>

          <b-row v-if="banderaBotonNuevaConciliacion == 2">
            <b-col>

              <b-row>
                <b-col>
                  <b-alert show variant="success">Se realizó la carga de su archivo de conciliación, verifique los
                    resultados</b-alert>
                </b-col>
              </b-row>

              <p></p>

              <b-row>
                <b-col>
                  <b-link @click="descargaResultadoConciliacion">Descargar Resultado</b-link>
                </b-col>
              </b-row>

              <p></p>

              <b-row>
                <b-col>
                  <b-button pill variant="success" size="lg" @click="cargarNuevaConciliacion()">Limpiar
                    formulario</b-button>
                </b-col>
              </b-row>

            </b-col>
          </b-row>

          <b-row v-if="banderaBotonNuevaConciliacion == 3">
            <b-col>

              <b-row>
                <b-col>
                  <b-button pill variant="success" size="lg" @click="cargarNuevaConciliacion()">Limpiar
                    formulario</b-button>
                </b-col>
              </b-row>

              <p></p>

              <b-row>
                <b-col>
                  <b-alert :variant="contenidoMensaje.includes('Error') ? 'danger' : 'success'" show>{{ contenidoMensaje
                  }}</b-alert>
                </b-col>
              </b-row>

            </b-col>
          </b-row>


        </b-tab>
      </b-tabs>


    </b-col>
  </b-row>

</template>

<script>
import axios from 'axios'
import FileSaver from 'file-saver';

export default {


  computed: {
    validaFormArchivoConcilia() {
      return this.conciliacionArchivo == null ? false : true
    },

    token: {
      get: function () {
        return this.$store.state.user.token;
      },
      set: function (newIsWorking) {
        this.$store.commit("updateToken", newIsWorking);
      }
    }
  },

  data() {
    return {
      //variables Generacion Vale
      cliente: "",
      //url: "http://192.168.0.100:8080/",
      //url: "https://optimal-central-pug.ngrok-free.app/",
      //url: "https://tphavawsqa.a.pinggy.link/",
      //url: "http://192.168.0.101:8080/",
      url: "https://recaudacion.gobrecservices.com/",

      archivoFacturas: null,
      archivoFacturasBase64: null,
      conciliacionArchivo: null,


      numeroFactura: '',
      folioFiscalFactura: '',
      fechaFactura: '',
      fechaFacturaInicio: '',
      fechaFacturaFinal: '',
      subTotalFactura: '',
      ivaFactura: '',
      totalFactura: '',
      proveedoresFactura: [],
      proveedorSelectedValFactura: '',

      facturasConciliacion: [],
      selectedFacturaConciliacion: '',

      banderaBotonNuevaCarga: 0,
      banderaBotonNuevaConciliacion: 0,

      checkAplicar: false,

      contenidoMensaje: '',

      contenidoAlertAltaFactura: '',

      resultadoConciliacionExcel: '',

      fechaRawFactura: null,
      fechaRawFacturaInicio: null,
      fechaRawFacturaFinal: null,

    }
  },


  created: function () {

    const queryString = window.location.href;

    const url = new URL(queryString);

    const cliente = url.pathname.split('/')[1];

    this.cliente = cliente

    axios({
      method: 'post',
      url: this.url + 'catalogosum',
      params: { "codeClient": this.cliente },
      data: null,
      headers: {
        'Authorization': this.token,

      }
    })
      .then((res) => {


        this.proveedoresFactura = res.data.proveedores
        this.facturasConciliacion = res.data.facturas

        this.proveedorSelectedValFactura = this.proveedoresFactura[0].proveedor


        if (this.facturasConciliacion != null && this.facturasConciliacion.length > 0) {
          this.selectedFacturaConciliacion = this.facturasConciliacion[0].descripcion
        }

      }).catch(err => {

        if (err.response.status == 400 || err.response.status == 304 || err.response.status == 403 || err.response.status == 404) {

          alert('Servicio no disponible, intente de nuevo más tarde');

        }

        else if (err.response.status == 500) {

          alert('Error en la red, verifique su conexión a internet 5');
        }

        else {

          alert(err);

        }
      });

  },

  methods: {

    //METODOS PARA CARGAR FACTURA

    enviarFactura() {

      this.banderaBotonNuevaCarga = 1;
      axios({
        method: "post",
        url: this.url + "registrafactura",

        data: {
          proveedor: this.proveedorSelectedValFactura,
          numero: this.numeroFactura,
          folioFiscal: this.folioFiscalFactura,
          fecha: this.fechaFactura,
          periodoInicial: this.fechaFacturaInicio,
          periodoFinal: this.fechaFacturaFinal,
          subtotal: this.subTotalFactura,
          iva: this.ivaFactura,
          total: this.totalFactura
        },

        headers: {
          'Authorization': this.token,
        },
      })
        .then((res) => {

          this.banderaBotonNuevaCarga = 2

          this.contenidoAlertAltaFactura = res.data

          //alert(this.contenidoAlertAltaFactura.proveedor)

          if (this.contenidoAlertAltaFactura.proveedor != null) {

            this.contenidoAlertAltaFactura = "FACTURA AGREGADA EXITOSAMENTE"

            this.refrescaCatalogos();

          }


        })
        .catch((err) => {
          //alert(err.config.headers.Authorization)

          //this.valorError = JSON.stringify(err.response);

          if (err.response.status == 400 || err.response.status == 304 || err.response.status == 403 || err.response.status == 404) {

            alert('Servicio no disponible, intente de nuevo más tarde');

            this.banderaBotonNuevaCarga = 0;
          }


          else if (err.response.status == 500) {

            alert('Error en la red, verifique su conexión a internet');
            this.banderaBotonNuevaCarga = 0;
          }

          else {

            if (err.config.headers.Authorization != null) {
              const queryString = window.location.href;
              const url = new URL(queryString);
              const cliente = url.pathname.split("/")[1];
              window.location.href = "/" + cliente + "/login";
            }

            //alert(err + " Servicio no disponible, intente de nuevo más tarde");

          }
        });
    },


    cargarNuevaFactura() {
      this.banderaBotonNuevaCarga = 0

      this.numeroFactura = '',
        this.folioFiscalFactura = '',
        this.fechaFactura = '',
        this.fechaFacturaInicio = '',
        this.fechaFacturaFinal = '',
        this.subTotalFactura = '',
        this.ivaFactura = '',
        this.totalFactura = '',
        this.proveedorSelectedValFactura = ''
    },

    //METODOS PARA CARGAR CONCILIACION

    cargarArchivoConciliacion(evt) {
      if (evt.target.files.length > 0) {
        this.cargarArchivoConciliacion2(evt.target.files[0]);
      }
    },

    cargarArchivoConciliacion2(f) {
      var reader = new FileReader();
      // Closure to capture the file information.
      let obj = this
      reader.onload = (function () {
        return function (theFile) {
          let binaryData = theFile.target.result;
          // Convertir datos binarios a base 64
          let base64String = window.btoa(binaryData);

          obj.conciliacionArchivo = base64String;
        };

      })(f);

      // Read in the image file as a data URL.
      reader.readAsBinaryString(f);
    },

    enviarConciliacion() {

      this.banderaBotonNuevaConciliacion = 1;
      axios({
        method: "post",
        url: this.url + "conciliacionfactura",

        data: {
          nombre: this.selectedFacturaConciliacion,
          xlsx: this.conciliacionArchivo,
          aplicar: this.checkAplicar
        },

        headers: {
          'Authorization': this.token,
        },
      })
        .then((res) => {


          if (res.data.xlsx) {
            //alert('entra al if del xlsx')
            this.registros = [];
            this.banderaBotonNuevaConciliacion = 2
            this.contenidoMensaje = res.data
            this.resultadoConciliacionExcel = res.data.xlsx
          }

          else {
            //alert('entra al if del mensaje')
            this.registros = [];
            this.banderaBotonNuevaConciliacion = 3
            this.contenidoMensaje = res.data
          }
        })
        .catch((err) => {

          //alert(err.config.headers.Authorization)

          //this.valorError = JSON.stringify(err.response);


          if (err.response.status == 400 || err.response.status == 304 || err.response.status == 403 || err.response.status == 404) {

            alert('Servicio no disponible, intente de nuevo más tarde');

            this.banderaBotonNuevaConciliacion = 0

          }

          else if (err.response.status == 500) {

            alert('Error en la red, verifique su conexión a internet');
            this.banderaBotonNuevaConciliacion = 0
          }

          else {

            if (err.config.headers.Authorization != null) {
              const queryString = window.location.href;
              const url = new URL(queryString);
              const cliente = url.pathname.split("/")[1];
              window.location.href = "/" + cliente + "/login";
            }



            //alert(err + " Servicio no disponible, intente de nuevo más tarde");

          }

        });
    },

    descargaResultadoConciliacion() {


      var byteString = atob(this.resultadoConciliacionExcel);
      var ab = new ArrayBuffer(byteString.length);
      var ia = new Uint8Array(ab);

      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }

      FileSaver.saveAs(new Blob([ab], { type: "application/octet-stream" }), 'Resultado.xlsx');


    },


    cargarNuevaConciliacion() {
      this.banderaBotonNuevaConciliacion = 0

      this.archivoFacturas = null
      this.archivoFacturasBase64 = null
      this.conciliacionArchivo = null
      this.selectedFacturaConciliacion = ''
      this.checkAplicar = false
    },

    refrescaCatalogos() {

      axios({
        method: 'post',
        url: this.url + 'catalogosum',
        params: { "codeClient": this.cliente },
        data: null,
        headers: {
          'Authorization': this.token,

        }
      })
        .then((res) => {


          this.proveedoresFactura = res.data.proveedores
          this.facturasConciliacion = res.data.facturas

          this.proveedorSelectedValFactura = this.proveedoresFactura[0].proveedor


          if (this.facturasConciliacion != null && this.facturasConciliacion.length > 0) {
            this.selectedFacturaConciliacion = this.facturasConciliacion[0].descripcion
          }

        }).catch(err => {

          if (err.response.status == 400 || err.response.status == 304 || err.response.status == 403 || err.response.status == 404) {

            alert('Servicio no disponible, intente de nuevo más tarde');

          }

          else if (err.response.status == 500) {

            alert('Error en la red, verifique su conexión a internet 5');
          }

          else {

            alert(err);

          }
        });
    },

    formateaFecha(fecha) {
      if (!fecha) return '';
      const date = new Date(fecha);
      const dia = String(date.getDate()).padStart(2, '0');
      const mes = String(date.getMonth() + 1).padStart(2, '0');
      const anio = date.getFullYear();
      return `${ dia }-${ mes }-${ anio }`;
    },

  },

  watch: {
    fechaRawFactura(val) {
      this.fechaFactura = this.formateaFecha(val);
    },
    fechaRawFacturaInicio(val) {
      this.fechaFacturaInicio = this.formateaFecha(val);
    },
    fechaRawFacturaFinal(val) {
      this.fechaFacturaFinal = this.formateaFecha(val);
    },
  },
}
</script>

<style>
/* BASIC */

html {
  background-color: #ffffff;
}

body {
  font-family: "Poppins", sans-serif;
  height: 100vh;
}

a {
  color: #ffffff;
  display: inline-block;
  text-decoration: none;
  font-weight: 400;
}

h2 {
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  text-transform: uppercase;
  display: inline-block;
  margin: 40px 8px 10px 8px;
  color: #cccccc;
}

/* STRUCTURE */

.wrapper {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  min-height: 100%;
  padding: 20px;
}

#formContent {
  -webkit-border-radius: 10px 10px 10px 10px;
  border-radius: 10px 10px 10px 10px;
  background: #fff;
  padding: 30px;
  width: 90%;
  max-width: 450px;
  position: relative;
  padding: 0px;
  -webkit-box-shadow: 0 30px 60px 0 rgba(0, 0, 0, 0.3);
  box-shadow: 0 30px 60px 0 rgba(0, 0, 0, 0.3);
  text-align: center;
}

#formFooter {
  background-color: #f6f6f6;
  border-top: 1px solid #dce8f1;
  padding: 25px;
  text-align: center;
  -webkit-border-radius: 0 0 10px 10px;
  border-radius: 0 0 10px 10px;
}

/* TABS */

h2.inactive {
  color: #cccccc;
}

h2.active {
  color: #0d0d0d;
  border-bottom: 2px solid #5fbae9;
}

/* FORM TYPOGRAPHY*/

input[type="button"],
input[type="submit"],
input[type="reset"] {
  background-color: #ffffff;
  border: none;
  color: white;
  padding: 15px 80px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  text-transform: uppercase;
  font-size: 13px;
  -webkit-box-shadow: 0 10px 30px 0 rgba(95, 186, 233, 0.4);
  box-shadow: 0 10px 30px 0 rgba(95, 186, 233, 0.4);
  -webkit-border-radius: 5px 5px 5px 5px;
  border-radius: 5px 5px 5px 5px;
  margin: 5px 20px 40px 20px;
  -webkit-transition: all 0.3s ease-in-out;
  -moz-transition: all 0.3s ease-in-out;
  -ms-transition: all 0.3s ease-in-out;
  -o-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
}

input[type="button"]:hover,
input[type="submit"]:hover,
input[type="reset"]:hover {
  background-color: #ffffff;
}

input[type="button"]:active,
input[type="submit"]:active,
input[type="reset"]:active {
  -moz-transform: scale(0.95);
  -webkit-transform: scale(0.95);
  -o-transform: scale(0.95);
  -ms-transform: scale(0.95);
  transform: scale(0.95);
}

input[type="text"] {
  background-color: #f6f6f6;
  border: none;
  color: #0d0d0d;
  padding: 15px 32px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 5px;
  width: 85%;
  border: 2px solid #f6f6f6;
  -webkit-transition: all 0.5s ease-in-out;
  -moz-transition: all 0.5s ease-in-out;
  -ms-transition: all 0.5s ease-in-out;
  -o-transition: all 0.5s ease-in-out;
  transition: all 0.5s ease-in-out;
  -webkit-border-radius: 5px 5px 5px 5px;
  border-radius: 5px 5px 5px 5px;
}

input[type="text"]:focus {
  background-color: #fff;
  border-bottom: 2px solid #5fbae9;
}

input[type="text"]:placeholder {
  color: #cccccc;
}

/* ANIMATIONS */

/* Simple CSS3 Fade-in-down Animation */
.fadeInDown {
  -webkit-animation-name: fadeInDown;
  animation-name: fadeInDown;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}

@-webkit-keyframes fadeInDown {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, -100%, 0);
    transform: translate3d(0, -100%, 0);
  }

  100% {
    opacity: 1;
    -webkit-transform: none;
    transform: none;
  }
}

@keyframes fadeInDown {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, -100%, 0);
    transform: translate3d(0, -100%, 0);
  }

  100% {
    opacity: 1;
    -webkit-transform: none;
    transform: none;
  }
}

/* Simple CSS3 Fade-in Animation */
@-webkit-keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@-moz-keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

.card-option {
  box-shadow: 0px 5px 35px 5px #cccaca;
  border-radius: 15px;
  border-bottom: solid 4px rgb(68, 63, 173);
  background-color: white;
}

.fadeIn {
  opacity: 0;
  -webkit-animation: fadeIn ease-in 1;
  -moz-animation: fadeIn ease-in 1;
  animation: fadeIn ease-in 1;

  -webkit-animation-fill-mode: forwards;
  -moz-animation-fill-mode: forwards;
  animation-fill-mode: forwards;

  -webkit-animation-duration: 1s;
  -moz-animation-duration: 1s;
  animation-duration: 1s;
}

.fadeIn.first {
  -webkit-animation-delay: 0.4s;
  -moz-animation-delay: 0.4s;
  animation-delay: 0.4s;
}

.fadeIn.second {
  -webkit-animation-delay: 0.6s;
  -moz-animation-delay: 0.6s;
  animation-delay: 0.6s;
}

.fadeIn.third {
  -webkit-animation-delay: 0.8s;
  -moz-animation-delay: 0.8s;
  animation-delay: 0.8s;
}

.fadeIn.fourth {
  -webkit-animation-delay: 1s;
  -moz-animation-delay: 1s;
  animation-delay: 1s;
}

/* Simple CSS3 Fade-in Animation */
.underlineHover:after {
  display: block;
  left: 0;
  bottom: -10px;
  width: 0;
  height: 2px;
  background-color: #56baed;
  content: "";
  transition: width 0.2s;
}

.underlineHover:hover {
  color: #0d0d0d;
}

.underlineHover:hover:after {
  width: 100%;
}

/* OTHERS */

*:focus {
  outline: none;
}

#icon {
  width: 60%;
}
</style>
